import React from 'react'

class Legal extends React.Component {
  render() {
    return (
    	<React.Fragment>
    		<section className="agency center-text bg--black">
    			<div className="row justify-content-around align-items-center container__full">
		    		<div className="col-10 col-sm-8 ">
				    	<h2>MENTIONS LÉGALES</h2>

				    </div>
			    </div>
		    </section>
	    	<section className="container">
	    		<div className="row">
  					<div className="col-sm-12 legal skills__desc">
		    			<p>Agence Cosmic ne garantit pas le fait que le serveur accueillant le site soit exempt de virus 
								ou qu’il ne puisse pas survenir un problème technique qui pourrait endommager les composants de 
								l’ordinateur de l’utilisateur ou des données qui pourraient y être stockées. En tout état de 
								cause Agence Cosmic, ou un de ses sous-traitants, ne pourra être responsable d’un dommage 
								quelconque pouvant se produire lors de la connexion sur le site.</p>
							<h2>COPYRIGHT</h2>
		    			<p>Agence Cosmic SAS.A. Au capital de 362.754 Euros, RCS Paris N°478 147 366 Tel : 01.49.58.58.58 
								Adresse : 2 Place du Colonel Fabien 75019 Paris<br/>
								TVA Intra: FR 964 781 473 66<br/>
								Aucune licence, ni aucun autre droit que celui de consulter le site n’est conféré à quiconque au 
								regard des droits de propriété intellectuelle. La reproduction des documents du site est autorisée 
								aux fins exclusives d’information pour un usage personnel et privé ; toute reproduction ou 
								utilisation de copies réalisées à d’autres fins est expressément interdite.</p>
							<p>Directeur de la publication : Valérie Piotte, Directrice Générale Agence Cosmic</p>
							<h2>Hébergement</h2>
							<p>Ce site est hébergé par MEDIACTIVE NETWORK - SAS au capital de 200 000 € - Adresse du siège social : 3-4-10 cité Paradis 75010 Paris. </p>
							<h2>Informatique et liberté</h2>
							<p>En application des articles 38 à 40 de la loi n° 78-17 du 6 janvier 1978, modifiée, par la loi 
								n° 2004-801 du 6 août 2004,  relative à l’informatique, aux fichiers et aux libertés et du 
								Règlement (UE) n°2016/79 du Parlement européen et du Conseil du 27 avril 2016 dit Règlement Général 
								sur la Protection des Données (RGPD), vous disposez d’un droit d’accès, de rectification, de 
								modification et de suppression des données qui vous concernent. Pour exercer ce droit, contactez-nous :<br/>
								Agence Cosmic, 2 Place du Colonel Fabien, 75019 Paris</p>
	    			</div>
	    		</div>

	    	</section>


	    </React.Fragment>
    )
  }
}

export default Legal



// WEBPACK FOOTER //
// ./src/containers/Legal.jsx